var $6b17f08f738443dc$exports = {};
const $6b17f08f738443dc$var$api_endpoint = "http://quotes.rest/quote/random?";
const $6b17f08f738443dc$var$api_key = "api_key=PtqjT6zPPhDa40sYxMz4OVIuwucXj2HS5izWCFb4";
$(document).ready(function() {
    $("#btn").click(function() {
        var category = "happiness";
        $.ajax({
            method: "GET",
            url: "https://api.api-ninjas.com/v1/quotes?category=" + category,
            headers: {
                "X-Api-Key": "47TbcbBJKlCP92xRufCnOg==PTkLKDxbwTowUKbb"
            },
            contentType: "application/json",
            success: function(result) {
                const results = result[0];
                $6b17f08f738443dc$var$setQuote(results);
                $(".card").effect("fade");
            },
            error: function ajaxError(jqXHR) {
                console.error("Error: ", jqXHR.responseText);
            }
        });
    });
});
function $6b17f08f738443dc$var$setQuote(result) {
    $("#author").html(result.author);
    $("#quote").html(result.quote);
    $("#category").html(result.category);
}


//# sourceMappingURL=index.e8dd755d.js.map
